export default class {
  constructor() {
    
    // Splide を使うため、スライダーがあるページでだけ読み込む
    const domPhilosophySlider = document.querySelector('[data-js="philosophy-slider"]');
    if (domPhilosophySlider) {
      import('./PhilosophySlider').then(({ default: PhilosophySlider }) => {
        new PhilosophySlider(domPhilosophySlider);
      });
    }

  }
}
